const state = () => ({
	name: 'Dashboard',
	sidebar:[],
	quickAddCache: Object.assign({}, JSON.parse(localStorage.getItem('quickAddCache')) || {})
})

const getters = {
	getName: state => state.name,
}

const mutations = {
	setSidebar: (state, payload) => state.sidebar = payload,
	setQuickAddCache: (state, payload) => {
		Object.assign(state.quickAddCache, { [payload.key]: payload.data });
		localStorage.setItem('quickAddCache', JSON.stringify(state.quickAddCache));
	},
	clearQuickAddCache: (state) => {
		Object.assign(state, { quickAddCache: {} });
		localStorage.removeItem('quickAddCache');
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations
}